import React, { ComponentProps, useMemo } from 'react'
import { renderToString } from 'react-dom/server'
import { tints } from '@manychat/manyui'

import {
  ContainerAppearance,
  ContentContainer,
} from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import TextWithIcon from 'common/builder/components/chart/FlowChart/nodes/shared/TextWithIcon/TextWithIcon'
import { AttachmentAppearance } from 'common/builder/components/chart/FlowChart/types/AttachmentAppearance'
import { FlowChartAttachment } from 'common/builder/components/chart/FlowChart/types/FlowChartAttachment'

interface AttachmentProps {
  attachment: FlowChartAttachment
  containerProps?: Partial<ComponentProps<typeof ContentContainer>>
}

export const AttachmentComponent = ({
  attachment: { icon: Icon, title, appearance },
  containerProps,
}: AttachmentProps) => {
  const IconString = useMemo(() => {
    return renderToString(<Icon size={64} color={tints.neutral[3]} />)
  }, [Icon])

  const containerPresentation =
    appearance === AttachmentAppearance.EXTERNAL
      ? ContainerAppearance.EXTERNAL
      : ContainerAppearance.DEFAULT

  const isEmpty = appearance === AttachmentAppearance.PLACEHOLDER

  return (
    <ContentContainer {...containerProps} appearance={containerPresentation} isEmpty={isEmpty}>
      <TextWithIcon icon={IconString} empty={isEmpty}>
        {title}
      </TextWithIcon>
    </ContentContainer>
  )
}
